"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const button_toolbar_1 = require("../button-toolbar");
const PageHeader = props => {
    const { children, message, data, sx = [] } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, justifyContent: "space-between", alignItems: "center", sx: [
            {
                alignItems: "center",
                justifyContent: "space-between",
                mb: 3,
                mt: 2,
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, sx: { mr: 2 }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "h2", sx: [
                        theme => ({
                            ...theme.typography.h4,
                            lineHeight: "52px",
                        }),
                    ], children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: message, values: data }) }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, sx: {
                    display: "flex",
                    flexGrow: 1,
                }, children: (0, jsx_runtime_1.jsx)(button_toolbar_1.ButtonToolbar, { children: children }) })] }));
};
exports.PageHeader = PageHeader;
//# sourceMappingURL=index.js.map